import React from 'react';
import { Modal, Button, Spinner, Alert, Row, Col, Form } from 'react-bootstrap';

const BatchConfigModal = ({
  show,
  onHide,
  loading,
  comandos,
  batchParams,
  onBatchParamsChange,
  onSave,
  retConfig,
  cmdToConfigMap,
  calibrationCommands,
  criticalCommands
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)', border: 'none' }}>
        <Modal.Title style={{ color: 'white', fontWeight: 600 }}>⚙️ Configuração em Lote</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', background: '#1e293b', color: '#e2e8f0' }}>
        <Alert variant="info" className="mb-3" style={{ background: 'rgba(59, 130, 246, 0.2)', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#93c5fd' }}>
          <strong>ℹ️ Como funciona:</strong> Preencha os campos desejados e clique em "Salvar Tudo". Os comandos serão enviados sequencialmente.
        </Alert>
        <Alert variant="secondary" style={{ background: 'rgba(100, 116, 139, 0.1)', border: '1px solid #475569', color: '#94a3b8', fontSize: '0.85em' }}>
          <strong>📡 Formato:</strong> <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>COMANDO:valor</code>
          <details style={{ marginTop: '8px', cursor: 'pointer' }}>
            <summary style={{ color: '#60a5fa', fontWeight: 500 }}>Ver exemplos →</summary>
            <div style={{ marginTop: '8px', padding: '8px', background: 'rgba(0,0,0,0.3)', borderRadius: '5px', fontSize: '0.8em', fontFamily: 'monospace' }}>
              <strong style={{ color: '#e2e8f0' }}>Comandos com 1 parâmetro:</strong>
              <div style={{ color: '#4ade80', marginLeft: '10px' }}>
                TDOSAN:5000 → Tempo máximo dosagem (5000ms)<br />
                TPSTAB:3000 → Tempo estabilização (3000ms)<br />
                FTAMPA:15 → Força motor abre tampa (15)<br />
                FRQVZ1:3612768 → Frequência vazio OSC1
              </div>
              <strong style={{ color: '#e2e8f0', marginTop: '10px', display: 'block' }}>Comandos especiais (2 parâmetros):</strong>
              <div style={{ color: '#fbbf24', marginLeft: '10px' }}>
                UMIRAN1:min:max → Range umidade OSC1 (Ex: UMIRAN1:0:60)<br />
                UMIRAN2:min:max → Range umidade OSC2 (Ex: UMIRAN2:0:60)
              </div>
              <small style={{ color: '#94a3b8', marginTop: '8px', display: 'block' }}>
                💡 Use a modal "Tabelas de Calibração" para CALDIAL1, CALCAPX1 e CHART1
              </small>
            </div>
          </details>
        </Alert>
        <Row className="g-3">
          {comandos.filter(c => c.params === 1 && !calibrationCommands.includes(c.cmd) && !criticalCommands.includes(c.cmd)).map(cmd => (
            <Col xs={12} md={6} key={cmd.cmd}>
              <Form.Group>
                <Form.Label style={{ fontSize: '0.9rem', fontWeight: 500, color: '#cbd5e1' }}>{cmd.label}</Form.Label>
                <Form.Control
                  type="number"
                  step="1"
                  size="sm"
                  value={batchParams[cmd.cmd] || ''}
                  onChange={e => onBatchParamsChange({ ...batchParams, [cmd.cmd]: e.target.value })}
                  placeholder={retConfig && cmdToConfigMap[cmd.cmd] ? `Atual: ${retConfig[cmdToConfigMap[cmd.cmd]]}` : 'Deixe vazio para não alterar'}
                  style={{ background: '#334155', border: '1px solid #475569', color: '#e2e8f0' }}
                />
              </Form.Group>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer style={{ background: '#0f172a', border: 'none' }}>
        <Button
          onClick={onHide}
          disabled={loading}
          style={{
            backgroundColor: 'transparent',
            color: '#6c757d',
            border: '1px solid #6c757d'
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={onSave}
          disabled={loading}
          style={{
            backgroundColor: 'var(--brand-light-green, #8fad15)',
            color: '#fff',
            border: 'none'
          }}
        >
          {loading ? <><Spinner animation="border" size="sm" className="me-2" />Salvando...</> : '💾 Salvar Tudo'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BatchConfigModal;
